import React, { useEffect } from "react";
import { useAuth } from "../modules/auth/useAuth";
import styled from "styled-components";
import { signOutClean } from "#/modules/auth/idp";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: var(--x-bg-main, #0D0A12);
    color: var(--x-gray-200, #FFFFFF);
`;

// Real logout route. Previously /logout just <Navigate>'d to /login without clearing
// anything; this clears the OIDC user + app-local state and redirects to the IdP
// sign-out endpoint, so it matches the header logout. Safe to deep-link to.
const Logout = (): JSX.Element => {
  const auth = useAuth();

  useEffect(() => {
    signOutClean(() => auth.removeUser());
  }, []);

  return (
    <Container>
      <h3>Signing out…</h3>
    </Container>
  );
};

export default Logout;
